import TablePagination from "../../../common/pagination/TablePagination";
import { Table } from "react-bootstrap";
import NotificationTableRow from "./NotificationTableRow";
import TableError from "../../common/TableError";
import { ITEMS_PER_PAGE } from "../../../../constant/constant";
import TableSkeleton from "../../common/TableSkeleton";
import RefreshButtonTable from "../../../common/RefreshButtonTable";

const NotificationTable = ({
  notifications,
  loading,
  error,
  metaData,
  currentPage,
  setCurrentPage,
  handleRefresh,
}) => {
  // Show skeleton only on initial load
  if (loading && notifications === undefined) {
    return <TableSkeleton rows={ITEMS_PER_PAGE} columns={4} />;
  }

  if (error || notifications === null) {
    return (
      <TableError
        error={error}
        handleRefresh={handleRefresh}
        loading={loading}
      />
    );
  }

  if (!notifications || notifications.length === 0) {
    return (
      <div className="alert alert-info mt-3" role="alert">
        No notifications sent yet.
      </div>
    );
  }

  const totalPages = metaData?.last_page || 1;

  return (
    <div>
      <RefreshButtonTable handleRefresh={handleRefresh} loading={loading} />

      <div className="custom-table-container mt-3">
        <div className="custom-table-wrapper">
          <Table hover className="custom-table">
            <thead className="custom-table-head">
              <tr>
                <th className="notification-col-title">Title</th>
                <th className="notification-col-desc">Description</th>
                <th className="notification-col-date">Sent Date</th>
                <th className="notification-col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {notifications.map((notification) => (
                <NotificationTableRow
                  key={notification.id}
                  notification={notification}
                />
              ))}
            </tbody>
          </Table>
        </div>

        <TablePagination
          totalPage={totalPages}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default NotificationTable;
